export enum CONFIG_TYPE {
  INTERNAL_BROKERAGE = "INTERNAL_BROKERAGE",
  EXTERNAL_BROKERAGE = "EXTERNAL_BROKERAGE",
  EXTERNAL_BROKERAGE_FLEX_FEES = "EXTERNAL_BROKERAGE_FLEX_FEES",
}

export const CONFIG_TYPES = [
  {
    value: CONFIG_TYPE.INTERNAL_BROKERAGE,
    label: "Internal Brokerage",
  },
  {
    value: CONFIG_TYPE.EXTERNAL_BROKERAGE,
    label: "External Brokerage",
  },
  {
    value: CONFIG_TYPE.EXTERNAL_BROKERAGE_FLEX_FEES,
    label: "External Brokerage with Fee Capitalisation",
  },
];
